const Loader: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
    return (
        <div id="preloader" className={!isLoading ? 'preloader-hide' : ''}>
            <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">

                </div>
            </div>
        </div>
    )
}

export default Loader;